import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Modal } from 'react-modal-bootstrap';
import Loader from '@components/Loader';

import InView from './../../utils/InView';

import {
  getDeliveryPreferences,
  getCartAmountBifurcation,
  changeShipmentPreference,
} from './../../actions';

import './style.scss';
import InfoCard from '../InfoCard/InfoCard';

const typeEnum = {
  NORMAL_BLACK: '0',
  BOLD_BLACK: '2',
  GREEN: '3',
  PURPLE: '4',
};

const initialState = {
  isLoading: false,
  isFetchingBifurcation: true,
  isScrollBottom: false,
  openSuccessOrderPopup: false,
};

class ReviewShipment extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  getDeliveryPreferences = () => {
    this.setState({
      isLoading: true,
    });

    const { hasOptedForTeleconsult, rxUploadLater, newImageUploaded } =
      this.props.data;

    const deilveryPreferencePayload = {
      hasOptedForTeleconsult,
      rxUploadLater,
      newImageUploaded,
    };

    this.props.getDeliveryPreferences(deilveryPreferencePayload).finally(() => {
      this.getCartAmountBifurcation();
      this.setState({
        isLoading: false,
      });
    });
  };

  getCartAmountBifurcation = () => {
    this.setState({
      isFetchingBifurcation: true,
      isScrollBottom: false,
    });

    const {
      hasOptedForTeleconsult,
      rxUploadLater,
      placementReason,
      newImageUploaded,
    } = this.props.data;

    const deliveryPreferences = [];

    this.props.deliveryPreferences.shipments.forEach(shipment => {
      const selectedDeliveryPreferencesObj = {
        shipmentId: shipment.id,
      };

      const selectedPreference = shipment.deliveryOptions.find(option => option.selected);

      if (selectedPreference && selectedPreference.id) {
        selectedDeliveryPreferencesObj.optionId = selectedPreference.id;
      }

      deliveryPreferences.push(selectedDeliveryPreferencesObj);
    });

    const cartAmountBifurcationPayload = {
      placementReason: placementReason.name,
      rxUploadLater: !!rxUploadLater,
      hasOptedForTeleconsult,
      deliveryPreferences,
      newImageUploaded,
    };

    this.props
      .getCartAmountBifurcation(cartAmountBifurcationPayload)
      .finally(() => {
        this.setState({
          isFetchingBifurcation: false,
        });
      });
  };

  componentDidMount() {
    this.getDeliveryPreferences();
  }


  handlePlaceOrder = () => {
    if (
      this.state.isLoading ||
      this.state.isFetchingBifurcation ||
      !this.state.isScrollBottom
    ) {
      return;
    }

    this.props.placeOrderV5();
  };

  getDisclamer = disclaimer => {
    const string = [];
    let count = 0;
    disclaimer.text.split(' ').forEach(element => {
      if (element === '%s') {
        string.push(
          `<span style=color:${disclaimer.placeHolder[0].color
          };font-weight:bold;>${disclaimer.placeHolder[count].value
          }</span>`
        );
        count++;
      } else {
        string.push(element);
      }
    });

    return (
      <div
        className="disclaimer"
        dangerouslySetInnerHTML={{ __html: string.join(' ') }}
      />
    );
  };

  handlePreferenceClick = (shipmentIndex, optionIndex) => {
    this.props.changeShipmentPreference(shipmentIndex, optionIndex);
    this.getCartAmountBifurcation();
  };

  getStyle = type => {
    switch (type) {
      case typeEnum.NORMAL_BLACK:
        return {};
      case typeEnum.BOLD_BLACK:
        return {
          color: '#4f585e',
          fontWeight: 'bold',
        };
      case typeEnum.GREEN:
        return {
          color: '#3bb896',
          fontWeight: 600,
        };
      case typeEnum.PURPLE:
        return {};
      default:
        return {};
    }
  };

  handleSliderItemInView = intersection => {
    const { inView } = intersection;
    if (inView) {
      this.setState({
        isScrollBottom: true,
      });
    }
  };

  scrollToBottom = () => {
    this.inView.scrollIntoView({ behavior: 'smooth' });
  };
  amountBifurcation = amountBifurcation => (amountBifurcation.map((bifurcation, index) => (
    <div key={index} className="bifurcation-container">
      {bifurcation.map((element, biIndex) => (
        <div>
          <div key={biIndex} className="bifurcation">
            <div className="text">
              {element.text} <InfoCard infoCard={element.infoCard} />
              {!!element.disclaimer && (
                <img
                  src={require('@images/info.svg')}
                  alt="i"
                  title={element.disclaimer.text || 'N/A'}
                />
              )}
            </div>
            <div className="value">
              {element.originalValue && element.finalValue ? (
                <span className="bothValue">
                  <span className="original">
                    {element.originalValue}
                  </span>
                  <span
                    className="final"
                    style={this.getStyle(element.type)}
                  >
                    {element.finalValue}
                  </span>
                </span>
              ) : (
                <span className="final">{element.finalValue}</span>
              )}
            </div>
          </div>
          {element.content && this.amountBifurcation(element.content)}
        </div>
      ))}
    </div>)
  ))
  render() {
    const { cardDetails = {}, shipments = [] } = this.props.deliveryPreferences;

    const { amountBifurcation } = this.props.cartAmountBifurcation;

    if (this.state.isLoading) {
      return <Loader />;
    }

    const isEnablePlaceOrder = shipments.every(shipment => shipment.deliveryOptions.some(shipment => shipment.selected));

    return (
      <Modal isOpen className="review-shipment-modal">
        <div
          className="review-shipment-container"
          ref={e => {
            this.reviewContainerRef = e;
          }}
        >
          <div className="header">
            <div className="heading">{cardDetails.header || ''}</div>
            <div className="subHeading">{cardDetails.subHeader || ''}</div>
            <div className="text">{cardDetails.text || ''}</div>
            <img src={require('@images/review_shipment.svg')} />
          </div>
          <div className="body">
            {shipments.map((shipment, index) => (
              <div key={shipment.id} className="shipment-container">
                <div className="count-card">
                  Shipment{' '}
                  <strong>
                    {index + 1} of {shipments.length}
                  </strong>
                </div>
                <div className="content">
                  <div className="products">
                    {shipment.items.map(item => (
                      <div key={item.itemId} className="product">
                        <div className="name">{item.name || 'N/A'}</div>
                        <div className="quantity">x {item.quantity}</div>
                      </div>
                    ))}
                  </div>
                  <div
                    className={cx('delivery-preferences', {
                      'pe-loading': this.state.isFetchingBifurcation,
                    })}
                  >
                    {shipment.deliveryOptions.map((option, optionIndex) => (
                      <div
                        className={cx('preference', {
                          selected: option.selected,
                        })}
                        key={option.id}
                        onClick={() =>
                          !option.selected && this.handlePreferenceClick(index, optionIndex)
                        }
                      >
                        <div className="radio-btn">
                          <div className="outer">
                            <div className="inner" />
                          </div>
                        </div>
                        <div className="time">{option.time}</div>
                        {(option.imageUrl || option.extraCharge) && (
                          <div className="preferenceType">
                            <span className="text">
                              {option.imageUrl ? (
                                <img src={option.imageUrl} />
                              ) : (
                                option.eddText
                              )}
                            </span>
                            &nbsp;|&nbsp;
                            {option.extraCharge && (
                              <span className="extraCharge">
                                {option.extraCharge}
                              </span>
                            )}
                          </div>
                        )}
                        {option.disclaimer &&
                          this.getDisclamer(option.disclaimer)}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}

            <div className="amount-bifurcation">
              {!this.state.isFetchingBifurcation &&
                this.amountBifurcation(amountBifurcation)
              }
            </div>
            {!this.state.isFetchingBifurcation && (
              <InView
                onChange={intersection =>
                  this.handleSliderItemInView(intersection)
                }
              >
                <div
                  style={{ float: 'left', clear: 'both' }}
                  ref={el => {
                    this.inView = el;
                  }}
                />
              </InView>
            )}
          </div>
        </div>
        <div className="footer">
          <div className="details">
            {!this.state.isFetchingBifurcation && amountBifurcation.length > 0 && (
              <span>
                <span className="price">
                  {
                    amountBifurcation[amountBifurcation.length - 1][0]
                      .finalValue
                  }
                </span>
                <br />
                <span className="detail-btn" onClick={this.scrollToBottom}>
                  View Details
                </span>
              </span>
            )}
          </div>
          <div className="action-btns">
            <div onClick={this.props.close} className="back-btn">
              GO BACK
            </div>
            <div
              onClick={this.handlePlaceOrder}
              className={cx('place-btn', {
                disable:
                  this.state.isLoading ||
                  this.state.isFetchingBifurcation ||
                  !this.state.isScrollBottom ||
                  !isEnablePlaceOrder,
              })}
            >
              PLACE ORDER
            </div>
          </div>
          {this.state.isFetchingBifurcation && (
            <div className="footer-loader" />
          )}
        </div>
      </Modal>
    );
  }
}

ReviewShipment.propTypes = {
  getDeliveryPreferences: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  deliveryPreferences: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
  placeOrderV5: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  getDeliveryPreferences,
  getCartAmountBifurcation,
  changeShipmentPreference,
};

function mapStateToProps(state) {
  return {
    deliveryPreferences: state.cart.deliveryPreferences,
    cartAmountBifurcation: state.cart.cartAmountBifurcation,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewShipment);
